export const downloadFile = (data: string, filename: string): void => {
  const blob = new Blob([data], { type: "text/json;charset=utf-8" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${filename}.json`;
  link.dispatchEvent(new MouseEvent("click"));
};
